import { fetchManagedContent } from "@/api/vtnz-backend/managedContent";
import type { FetchState } from "@/types/sharedTypes";
import { defineStore } from "pinia";
import { computed, ref } from "vue";

export interface ManagedContent {
  /** database unique identifier. */
  id: string;
  /** title to display to the user. */
  name: string;
  /** Description describing the intent for this content. NOTE: not for user display */
  description: string;
  /** WYSIWYG generated HTML string to be rendered. */
  content: string;
  /** unique more verbose identify for locating the correct content.  NOTE: not for user display */
  identifier: string;
  /** type of managed content */
  type?: "tooltip";
}

export const useContentStore = defineStore("contentStore", () => {
  /** indicates te trip stores current data fetching state. */
  const fetchState = ref<FetchState>("idle");

  /** error message for last fetching error if there is one. */
  const errorMsg = ref<string | null>(null);

  /** helper flag to indicated async fetching is in operation. Good for loading animations. */
  const isFetching = computed(() => fetchState.value === "loading");

  const tooltips = ref<Record<string, ManagedContent>>({});

  function getTooltip(key: string): ManagedContent | undefined {
    return tooltips.value[key];
  }

  async function fetchContent() {
    fetchState.value = "loading";
    errorMsg.value = null;

    const fetchRes = await fetchManagedContent();

    if (!fetchRes.success) {
      errorMsg.value = fetchRes.errorMsg;
      fetchState.value = "error";
      return;
    }

    const newTooltips: Record<string, ManagedContent> = {};

    fetchRes.data.forEach((d) => {
      newTooltips[d.identifier] = {
        id: d.id,
        content: "TODO: find out why no one is serving the main prop",
        description: d.description ?? "",
        identifier: d.identifier,
        name: "TODO: find out why no one is service the second most important prop",
        type: "tooltip",
      };
    });

    tooltips.value = newTooltips;
    fetchState.value = "success";
  }

  return {
    /** indicates te trip stores current data fetching state */
    fetchState,

    /** error message for last fetching error if there is one. */
    errorMsg,

    /** helper flag to indicated async fetching is in operation. Good for loading animations. */
    isFetching,

    /** find the correct tooltip */
    getTooltip,

    /** fetch */
    fetchContent,
  };
});
